import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  Center,
  Heading
} from '@chakra-ui/react';
import { MdPhone, MdSupportAgent, MdOutlineMessage } from 'react-icons/md';
import { formatDate } from '@utils/dateUtils';
import {
  formatCallStatus,
  getCallStatusColor
} from '@views/OutboundCallingDashboard/utils';

/**
 * Call History List Component
 * Displays list of past calls for a ticket using callAttempts from ticket data
 */
const CallHistoryList = ({ ticket }) => {
  const callAttempts = ticket?.callAttempts || [];

  /**
   * Empty state
   */
  if (!callAttempts || callAttempts.length === 0) {
    return (
      <Box
        bg="whiteAlpha.50"
        p={8}
        borderRadius="lg"
        border="1px dashed"
        borderColor="whiteAlpha.300"
      >
        <Center>
          <VStack spacing={2}>
            <MdPhone boxSize={8} color="gray.500" />
            <Text color="gray.400" fontSize="sm">
              No call history yet
            </Text>
            <Text color="gray.500" fontSize="xs">
              Log your first call below
            </Text>
          </VStack>
        </Center>
      </Box>
    );
  }

  return (
    <VStack spacing={3} align="stretch" maxH="400px" overflowY="auto">
      {callAttempts.map((attempt, index) => (
        <Box
          key={`${attempt.orderId}-${attempt.callAttemptTimestamp}-${index}`}
          bg={'backGround'}
          p={4}
          borderRadius="lg"
          border="1px solid"
          borderColor="whiteAlpha.200"
          _hover={{
            bg: 'whiteAlpha.100',
            borderColor: 'whiteAlpha.300'
          }}
          transition="all 0.2s"
        >
          <VStack align="stretch" spacing={2}>
            {/* First Row: Date/Time and Call Status */}
            <HStack justify="space-between" align="center">
              <Heading fontSize="ld" color="gray.400">
                {formatDate(attempt.callAttemptTimestamp)}
              </Heading>

              <Badge
                colorScheme={getCallStatusColor(attempt.callStatus)}
                fontSize="xs"
                px={2}
                borderRadius={'xl'}
              >
                {formatCallStatus(attempt.callStatus)}
              </Badge>
            </HStack>

            {/* Second Row: Agent ID */}
            <HStack spacing={2}>
              <HStack>
                <MdSupportAgent color={'gray'} />
                <Text fontSize="sm" fontWeight="semibold" color="white">
                  {attempt.agentId}
                </Text>
              </HStack>
            </HStack>

            {/* Third Row: Agent Remarks (italic with quotes) */}
            {attempt.agentRemarks && (
              <HStack spacing={2} align="start">
                <MdOutlineMessage color="gray" size={16} />
                <Text fontSize="sm" color="gray.300" fontStyle="italic">
                  "{attempt.agentRemarks}"
                </Text>
              </HStack>
            )}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
};

export default CallHistoryList;
